import { Plan } from '../index';

export const PlanInfo: Record<
  Plan,
  { planName: string; header: string; subheader: string }
> = {
  infinity: {
    planName: 'Infinity',
    header: 'Greenlight Infinity†',
    subheader:
      'Best for families who want our highest rewards, safety tools, and investing.'
  },
  max: {
    planName: 'Max',
    header: 'Greenlight Max',
    subheader:
      'Best for families who want to invest in their future and protect their purchases, phones, and identity.'
  },
  standard: {
    planName: 'Core',
    header: 'Greenlight Core',
    subheader: 'Best for families who are starting out their journeys.'
  }
};

export const infinityCheckListDetails = [
  {
    heading: 'Priority customer support',
    details: 'Your calls go to the front of the line'
  },
  {
    heading: 'Cell phone protection',
    details: 'Coverage for damaged, lost or stolen phones; for up to 5 kids²'
  },
  {
    heading: 'Purchase protection',
    details: 'Repair or replace purchases that are stolen or damaged²'
  },
  {
    heading: 'Identity theft protection',
    details:
      'Identity theft monitoring, alerting and restoration for the whole family'
  }
];

export const maxCheckListDetails = [
  {
    heading: 'Cash rewards',
    details: 'Kids earn 1% Cash Back on purchases, and 2% on Savings¹'
  },
  {
    heading: 'Priority customer support',
    details: 'Your calls go to the front of the line'
  },
  {
    heading: 'Cell phone protection',
    details: 'Coverage for damaged, lost or stolen phones; for up to 5 kids²'
  },
  {
    heading: 'Purchase protection',
    details: 'Repair or replace purchases that are stolen or damaged²'
  },
  {
    heading: 'Identity theft protection',
    details:
      'Identity theft monitoring, alerting and restoration for the whole family'
  }
];

export const coreChecklist = [
  {
    heading: 'Investing for Parents',
    details:
      'Limited investing — choose between 10 ETs with personalized recommendations'
  },
  {
    heading: 'Flexible spend controls',
    details: 'Choose when and where they spend with real-time notifications'
  },
  {
    heading: 'Savings goals',
    details: 'Kids can set savings goals and track their progress'
  },
  {
    heading: 'Allowance on autopilot',
    details: 'Automate your kids’ allowance and never miss a payday again'
  },
  {
    heading: 'Cash rewards',
    details: 'Kids earn 1% on Savings¹'
  },
  {
    heading: 'Direct deposit',
    details: 'Send paychecks directly to their Greenlight card'
  }
];

export const maxDetails = [
  {
    image: 'research.svg',
    heading: 'Research',
    details: 'Explore 4,000+ stocks and ETFs with expert analysis'
  },
  {
    image: 'invest.svg',
    heading: 'Invest',
    details: 'Buy stocks with your kids and start investing for their futures'
  },
  {
    image: 'learn.svg',
    heading: 'Learn',
    details:
      "Track performance, access educational content, and strengthen both you and your kid's financial literacy"
  }
];

export const infinityDetails = [
  {
    image: 'investing.svg',
    heading: 'Investing',
    details: 'Kids and parents can invest in 4,000 + stocks and ETFs'
  },
  {
    image: 'rewards.svg',
    heading: 'Higher rewards',
    details: 'Earn 5% on savings and 1% cash back¹'
  },
  {
    image: 'location.svg',
    heading: 'Family location sharing',
    details: 'Know where your family is at any time'
  },
  {
    image: 'driving-safety.svg',
    heading: 'Driving safety & SOS',
    details: 'Crash detection and emergency SOS alerts'
  }
];

export const coreDetails = [
  {
    image: 'save.svg',
    heading: 'Debit card',
    details: 'Up to 5 debit cards for your kids'
  },
  {
    image: 'allowance.svg',
    heading: 'Instant money transfers',
    details: 'Send money to your kids — anytime, anywhere'
  },
  {
    image: 'savings-rewards.svg',
    heading: 'Chore management',
    details: 'Track your kids’ chores and tie the work to perks'
  }
];
